var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuExtend = function SvgMenuExtend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    viewBox: "0 0 60 60",
    overflow: "visible"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8 60H9.2c-5 0-9.2-4.1-9.2-9.2V9.2C0 4.1 4.1 0 9.2 0h41.7c5 0 9.2 4.1 9.2 9.2v41.7a9.31 9.31 0 0 1-9.3 9.1zM9.2 3.7c-3 0-5.5 2.5-5.5 5.5v41.7c0 3 2.5 5.5 5.5 5.5h41.7c3 0 5.5-2.5 5.5-5.5V9.2c0-3-2.5-5.5-5.5-5.5H9.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8,9.2c0-4,3.3-7.3,7.3-7.3h6.8v56.3H9.2c-4,0-7.3-3.3-7.3-7.3V9.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9 60H9.2c-5 0-9.2-4.1-9.2-9.2V9.2C0 4.1 4.1 0 9.2 0H16a1.79 1.79 0 0 1 1.8 1.8v56.3c-.1 1.1-.9 1.9-1.9 1.9zM9.2 3.7c-3 0-5.5 2.5-5.5 5.5v41.7c0 3 2.5 5.5 5.5 5.5h4.9V3.7H9.2zM30 45.9c-.5 0-.9-.2-1.3-.5-.7-.7-.7-1.9 0-2.6L41.5 30 28.7 17.2c-.7-.7-.7-1.9 0-2.6s1.9-.7 2.6 0l14.1 14.1c.7.7.7 1.9 0 2.6L31.3 45.4c-.4.3-.8.5-1.3.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1 31.8H15.9a1.79 1.79 0 1 1 0-3.6h28.2a1.79 1.79 0 1 1 0 3.6z"
  })));
};
export default SvgMenuExtend;